import { client } from "../client";
import { CommandExport } from "../types/command_export.types";

export const fetchCommandExports = async () => {
	const response = await client.get<CommandExport[]>(`commands/exports/`);
	return response.data;
};
